import React from 'react';

import PropTypes from 'prop-types';

import ClientCard from '@/components/CommercialPage/ClientList/ClientCard';
import CardList from '@/components/common/CardList';
import Spinner from '@/components/common/Spinner';

const ClientListComponent = ({ busy, clients, loadMore, hasMore, scrollParentRef }) =>
  busy ? (
    <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <Spinner className="w-8 h-8 text-[#5181C1] animate-spin" />
    </div>
  ) : (
    <CardList
      cards={clients}
      Element={ClientCard}
      hasMore={hasMore}
      loadMore={loadMore}
      scrollParentRef={scrollParentRef}
    />
  );

ClientListComponent.propTypes = {
  busy: PropTypes.bool.isRequired,
  clients: PropTypes.array.isRequired,
  loadMore: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  scrollParentRef: PropTypes.object,
};

export default ClientListComponent;
